import React from 'react';

import { Link } from '@mui/material';

import { FormikProps } from 'formik';
import { Constants, InputTypes } from '../../../../helpers/Constants';
import strings from '../../../../localization';

import CustomDatePicker from '../../../common/CustomDatePicker';
import { serverToday } from '../../../../helpers/Functions';

import styles from './styles';

const { text, component } = Constants.formInputType;
const serverDate = serverToday();

export const editEntitlementFieldConfig = (formik: FormikProps<any>) =>
  [
    {
      xs: 3,
      key: '1',
      name: 'pharmacyName',
      label: strings.pharmacyName,
      type: text,
      disabled: true,
      placeholder: ' ',
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 3,
      key: '2',
      name: 'pharmacyEmail',
      label: strings.pharmacyEmail,
      type: text,
      disabled: true,
      placeholder: ' ',
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 3,
      key: '3',
      name: 'campaignName',
      label: strings.campaignName,
      type: text,
      disabled: true,
      placeholder: ' ',
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 3,
      key: '4',
      name: 'totalCredits',
      label: strings.totalCredits,
      type: text,
      customType: InputTypes.number,
      requireLabel: true,
      placeholder: ' ',
      customTextFieldContainer: styles.fieldContainer,
    },
    {
      xs: 3,
      key: '4',
      name: 'validUntil',
      label: strings.creditsValidUntil,
      type: component,
      renderComponent: () =>
        (
          <CustomDatePicker
            label={strings.creditsValidUntil}
            name="validUntil"
            minDate={serverDate}
            readOnly
            error={
          (formik.touched.validUntil
            && formik.errors.validUntil) as string
        }
            formik={formik}
          />
        ),
    },
  ];

const currentScreen = (
  <Link
    key="curr"
    href={Constants.paths.admin.entitlements}
    sx={[styles.noUnderline, styles.prevLink]}
  >
    {strings.entitlements}
  </Link>
);

export const editCrumbs = [
  currentScreen,
  <Link
    href={Constants.paths.admin.editEntitlement}
    sx={styles.noUnderline}
    key="edit"
  >
    {strings.editEntitlement}
  </Link>,
];
